import React from 'react';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import PaymentRequestStatusChangeItem from '../../../../Domain/PaymentRequestStatusChangeItem';

export default class PaymentRequestStatusChangeWindowDescription extends React.Component {
  static titleForCreate = 'Payment Request Status Change';
  static titleForEdit = 'Payment Request Status Change';
  static itemType = PaymentRequestStatusChangeItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.AdvancePaymentRequestWorkflow(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static validityCheckerForComment(e, editedItem) {
    if (editedItem && ['10', '11', '12', '14', '15'].includes(editedItem.Action) && editedItem.Comment === '') {
      return "This field can't be empty.";
    }
    return '';
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Action',
          label: 'Action',
          className: 'col-12',
          type: InputTypesEnum.PaymentRequestStatusChangeSelect,
          EntityId: 'IeId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: PaymentRequestStatusChangeWindowDescription.validityCheckerForComment,
        },
      ],
    },
  ];
}
